export default "__VITE_ASSET__CuHy$83N__"